import { render, staticRenderFns } from "./AppCookies.vue?vue&type=template&id=48c36026&scoped=true"
import script from "./AppCookies.vue?vue&type=script&lang=js"
export * from "./AppCookies.vue?vue&type=script&lang=js"
import style0 from "./AppCookies.vue?vue&type=style&index=0&id=48c36026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c36026",
  null
  
)

export default component.exports